import { TRASH_PROPERTY_PSEUDO_DUID } from "~/constants/property";
import { DartboardKind, FilterApplicability, FilterConnector, StatusKind, ViewKind } from "~/shared/enums";
import type { Filter } from "~/shared/types";

export const WORKING_STATUS_KINDS = new Set([StatusKind.UNSTARTED, StatusKind.STARTED]);
export const COMPLETED_STATUS_KINDS = new Set([StatusKind.FINISHED, StatusKind.CANCELED]);

export const NONACTIVE_DARTBOARD_KINDS = new Set([DartboardKind.NEXT, DartboardKind.BACKLOG]);

export const DROP_HOVER_STYLE = "bg-primary-base/25"; // TODO move to styles
export const MAX_TIMEOUT = 2 ** 31 - 1;
export const MOVE_REPEAT_DELAY_MS = 500;

export const UNASSIGNED_ASSIGNEE_LABEL = "(Unassigned)";
export const UNASSIGNED_PSEUDO_ASSIGNEE_KEY = "@unassigned";
export const UNSET_USER_LABEL = "(Unset)";
export const DEACTIVATED_USER_LABEL = "(Former user)";

export const SPRINT_DARTBOARD_KINDS = [
  DartboardKind.ACTIVE,
  DartboardKind.NEXT,
  DartboardKind.BACKLOG,
  DartboardKind.FINISHED,
] as const;
export const SPRINT_DARTBOARD_KINDS_SET: Set<DartboardKind> = new Set(SPRINT_DARTBOARD_KINDS);

export const NONCUSTOM_VIEW_KINDS = new Set([ViewKind.SEARCH, ViewKind.TRASH, ViewKind.MY_TASKS]);

export const DEFAULT_ASSIGNEES_FILTER_PARTIAL: Omit<Filter, "propertyDuid" | "values"> = {
  id: "assignee",
  applicability: FilterApplicability.IS,
  connector: FilterConnector.OR,
};

export const DEFAULT_STATUS_FILTER_PARTIAL: Omit<Filter, "propertyDuid" | "values"> = {
  id: "status",
  applicability: FilterApplicability.IS_NOT,
  connector: FilterConnector.OR,
};

export const DEFAULT_DARTBOARD_FILTER_PARTIAL: Omit<Filter, "propertyDuid" | "values"> = {
  id: "dartboard",
  applicability: FilterApplicability.IS_NOT,
  connector: FilterConnector.OR,
};

export const TRASH_FILTER: Filter = {
  id: "trash",
  propertyDuid: TRASH_PROPERTY_PSEUDO_DUID,
  applicability: FilterApplicability.EXIST,
  connector: FilterConnector.AND,
  values: [],
  locked: true,
};

export const TASK_CONTEXT_MENU_OPTIONS = {
  maxHeightPixels: 960,
  widthPixels: 280,
};

export const AG_GRID_BODY_SELECTOR = ".ag-grid-viewport";
